import React from 'react';
import { ASSETS } from '../../assetManifest.js';
import { getBreedingRecipe } from '../../gameLogic/breedingLogic.js';
import { getEncyclopediaUnlockCost } from '../../gameLogic/unlockLogic.js';
import { groupDragonsByRarity, getRarityColor, getElementColor, getElementGlow } from '../../utils/gameUtils.js';
import { getAssetKey } from '../../utils/assetUtils.js';

const EncyclopediaTab = ({ 
  unlockedRecipes, 
  coins, 
  keys, 
  onUnlockRecipeWithCoins, 
  onUnlockRecipeWithKey 
}) => {
  const encyclopediaDragons = groupDragonsByRarity();

  return (
    <div className="card-enhanced h-full flex flex-col">
      <div className="flex items-center space-x-3 mb-4 flex-shrink-0">
        <h2 className="text-2xl font-mono font-semibold text-blue-400 text-glow">Tome of Dragons</h2>
      </div>
      
      <div className="flex-1 overflow-y-auto custom-scrollbar pr-2 -mr-2">
        {Object.entries(encyclopediaDragons).map(([rarity, dragons]) => (
          <div key={rarity} className="mb-6">
            <h3 className="text-lg font-mono font-bold mb-3 flex items-center" style={{ color: getRarityColor(rarity) }}>
              {rarity} Dragons
              <div className="ml-2 w-3 h-3 rounded-full" style={{ backgroundColor: getRarityColor(rarity) }}></div>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {dragons.map(dragon => {
                const isRecipeUnlocked = unlockedRecipes.includes(dragon.name);
                const recipe = getBreedingRecipe(dragon.name);
                const unlockCost = getEncyclopediaUnlockCost(dragon.name);

                return (
                  <div key={dragon.name} className="bg-gray-900/50 p-4 rounded-lg border border-transparent hover:border-white/20 hover:bg-gray-900/80 relative overflow-hidden"
                      style={{ '--element-color': getElementColor(dragon.element) }}>
                    <div className="absolute top-0 left-0 w-full h-1 bg-[var(--element-color)] opacity-50"></div>
                    <div className="flex flex-col items-center text-center">
                      <div className="relative mb-3">
                        <img
                          src={ASSETS.dragons[getAssetKey(dragon.name)].path}
                          alt={dragon.name}
                          className="w-16 h-16"
                          style={{ filter: `drop-shadow(0 0 6px ${getElementGlow(dragon.element)})` }}
                        />
                      </div>
                      <p className="text-sm font-mono font-bold mb-1">{dragon.name}</p>
                      <p className="text-xs font-sans mb-3" style={{ color: getElementColor(dragon.element) }}>
                        {dragon.element}
                      </p>
                    </div>

                    {isRecipeUnlocked && recipe ? (
                      <div className="bg-black/20 p-2 rounded text-center">
                        <p className="text-xs text-green-400 mb-1 font-sans">Recipe:</p>
                        <div className="flex items-center justify-center space-x-1 font-sans">
                          <span className="text-xs">{recipe[0]}</span>
                          <span className="text-xs text-gray-400">+</span>
                          <span className="text-xs">{recipe[1]}</span>
                        </div>
                      </div>
                    ) : recipe ? (
                      <div className="space-y-2">
                        <button
                          onClick={() => onUnlockRecipeWithCoins(dragon.name)}
                          disabled={coins < unlockCost}
                          className="btn btn-primary w-full text-xs py-2"
                        >
                          Unlock ({unlockCost.toLocaleString()})
                        </button>
                        <button
                          onClick={() => onUnlockRecipeWithKey(dragon.name)}
                          disabled={keys < 1}
                          className="btn btn-secondary w-full text-xs py-2"
                        >
                          Unlock (1 🗝️)
                        </button>
                      </div>
                    ) : (
                      <div className="bg-black/20 p-2 rounded">
                        <p className="text-xs text-gray-400 text-center font-sans">Basic Dragon</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EncyclopediaTab;
